import React, { useCallback, useEffect, useState } from "react";
import Table from "../../components/Table/Table";
import styles from "assets/jss/material-dashboard-pro-react/components/tableStyle";
import withStyles from "@material-ui/core/styles/withStyles";
import MarketSelector from "../../components/CustomDropdown/MarketSelector";
import Overlay from "../../components/Overlay/Overlay";
import CustomInput from "../../components/CustomInput/CustomInput";
import { Dialog } from "@material-ui/core";
import GridContainer from "../../components/Grid/GridContainer";
import GridItem from "../../components/Grid/GridItem";
import { SmallUppercase } from "../../text";
import RegularButton from "../../components/CustomButtons/Button";
import Check from "@material-ui/icons/Check";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import _ from "lodash";
import Checkbox from "@material-ui/core/Checkbox";
import IconButton from "@material-ui/core/IconButton";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";
import { connect } from "react-redux";
import { addUser } from "../../api";

class NewUserModal extends React.Component {
  state = {
    first_name: "",
    last_name: "",
    email: "",
    permissions: [{ seller: "", permissions: [] }],
    error: null,
    globalAdmin: false,
    loading: false,
  };

  submit = () => {
    const {
      first_name,
      last_name,
      email,
      permissions,
      globalAdmin,
    } = this.state;
    this.setState({loading: true}, () => {
      addUser({ first_name, last_name, email, permissions, admin: globalAdmin }).then( () => {
        this.setState({loading:false})
        this.props.closeNewUserModal(true)
      }).catch( () => {
        //axios middleware is gonna throw error popup already
        this.setState({loading:false})
      })
    });
  };
  sellerChange = (idx, e) => {
    for (let i = 0; i < this.state.permissions.length; i++) {
      if (i === idx) {
        continue;
      }
      if (this.state.permissions[i].seller === e.target.value) {
        this.setState({
          error: "You already have this location selected in another row",
        });
        return;
      }
    }
    this.state.permissions[idx].seller = e.target.value;
    this.setState({ permissions: this.state.permissions });
  };

  handleToggle = (idx, field) => {
    if (this.state.permissions[idx].permissions.includes(field)) {
      _.remove(this.state.permissions[idx].permissions, (x) => x === field);
    } else {
      this.state.permissions[idx].permissions.push(field);
    }
    this.setState({ permissions: this.state.permissions });
  };
  removeRow = (idx) => {
    this.state.permissions.splice(idx, 1);
    if (this.state.permissions.length === 0) {
      this.state.permissions.push({ seller: "", permissions: [] });
    }
    this.setState({ permissions: this.state.permissions });
  };
  readyToSubmit = () => {
    const {
      first_name,
      last_name,
      email,
      permissions,
      globalAdmin,
    } = this.state;
    if (!first_name || !last_name || !email) {
      return false;
    }
    if (permissions.length === 0 && !globalAdmin) {
      return false;
    }
    if (!globalAdmin) {
      for (let i = 0; i < permissions.length; i++) {
        if (permissions[i].seller === "") {
          return false;
        }
      }
    }

    return true;
  };

  handleGlobalAdmin = () => {
    this.setState({ globalAdmin: !this.state.globalAdmin });
  };
  render() {
    const {
      loading,
      permissions,
      first_name,
      last_name,
      email,
      error,
      globalAdmin,
    } = this.state;
    const { classes, stores, user } = this.props;

    let rows = permissions.map((row, idx) => {
      let addButton = (
        <>
          <IconButton onClick={() => this.removeRow(idx)}>
            <RemoveCircleIcon style={{ color: "red" }} />
          </IconButton>{" "}
        </>
      );
      if (
        idx === permissions.length - 1 &&
        permissions.length < stores.length
      ) {
        addButton = (
          <>
            <IconButton onClick={() => this.removeRow(idx)}>
              <RemoveCircleIcon style={{ color: "red" }} />
            </IconButton>
            <IconButton
              onClick={() => {
                this.state.permissions.push({ seller: "", permissions: [] });
                this.setState({ permissions: this.state.permissions });
              }}
            >
              <AddCircleIcon style={{ color: "green" }} />
            </IconButton>
          </>
        );
      }
      return [
        <MarketSelector
          onChange={(e) => this.sellerChange(idx, e)}
          useFullID
          value={row.seller}
        />,
        <Checkbox
          checked={row.permissions.includes("stock")}
          onClick={(e) => this.handleToggle(idx, "stock", e)}
          checkedIcon={<Check className={classes.checkedIcon} />}
          icon={<Check className={classes.uncheckedIcon} />}
          classes={{
            checked: classes.checked,
            root: classes.checkRoot,
          }}
        />,
        <Checkbox
          checked={row.permissions.includes("pricing")}
          onClick={(e) => this.handleToggle(idx, "pricing", e)}
          checkedIcon={<Check className={classes.checkedIcon} />}
          icon={<Check className={classes.uncheckedIcon} />}
          classes={{
            checked: classes.checked,
            root: classes.checkRoot,
          }}
        />,
        <Checkbox
          checked={row.permissions.includes("deals")}
          onClick={(e) => this.handleToggle(idx, "deals", e)}
          checkedIcon={<Check className={classes.checkedIcon} />}
          icon={<Check className={classes.uncheckedIcon} />}
          classes={{
            checked: classes.checked,
            root: classes.checkRoot,
          }}
        />,
        <Checkbox
          checked={row.permissions.includes("user_management")}
          onClick={(e) => this.handleToggle(idx, "user_management", e)}
          checkedIcon={<Check className={classes.checkedIcon} />}
          icon={<Check className={classes.uncheckedIcon} />}
          classes={{
            checked: classes.checked,
            root: classes.checkRoot,
          }}
        />,
        addButton,
      ];
    });
    return (
      <Dialog maxWidth="lg" fullWidth open={true}>
        {loading && <Overlay type="loading" />}
        {error && (
          <Overlay
            type="error"
            message={error}
            dismiss={
              <RegularButton
                size="sm"
                color="primary"
                onClick={() => {
                  this.setState({ error: null });
                }}
              >
                Dismiss
              </RegularButton>
            }
          />
        )}
        <GridItem xs={12}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={3}>
              <CustomInput
                formControlProps={{
                  fullWidth: true,
                }}
                labelText="First Name"
                inputProps={{
                  value: first_name,
                  onChange: (e) => {
                    this.setState({ first_name: e.currentTarget.value });
                  },
                }}
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={3}>
              <CustomInput
                formControlProps={{
                  fullWidth: true,
                }}
                labelText="Last Name"
                inputProps={{
                  value: last_name,
                  onChange: (e) => {
                    this.setState({ last_name: e.currentTarget.value });
                  },
                }}
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={6}>
              <CustomInput
                formControlProps={{
                  fullWidth: true,
                }}
                fullWidth
                labelText="Email"
                inputProps={{
                  value: email,
                  onChange: (e) => {
                    this.setState({ email: e.currentTarget.value });
                  },
                }}
              />
            </GridItem>
          </GridContainer>
          {user && user.type === "saucey_admin" && (
            <>
              <Checkbox
                checked={globalAdmin}
                onClick={this.handleGlobalAdmin}
                checkedIcon={<Check className={classes.checkedIcon} />}
                icon={<Check className={classes.uncheckedIcon} />}
                classes={{
                  checked: classes.checked,
                  root: classes.checkRoot,
                }}
              />{" "}
              Global Admin
            </>
          )}
          {!globalAdmin && (
            <GridContainer>
              <GridItem xs={12}>
                <Table
                  striped
                  tableHead={[
                    "Location",
                    "Stock",
                    "Pricing",
                    "Deals",
                    "User Management",
                    "",
                  ]}
                  hits={[]}
                  tableData={rows}
                  customCellClasses={[
                    classes.noPadding,
                    classes.noPadding,
                    classes.noPadding,
                    classes.noPadding,
                    classes.right,
                  ]}
                  customClassesForCells={[1, 2, 3, 4, 5]}
                  customHeadCellClasses={[classes.noPadding]}
                  customHeadClassesForCells={[7]}
                />
              </GridItem>
            </GridContainer>
          )}
          <GridContainer>
            <GridItem xs={12} style={{ textAlign: "right" }}>
              <RegularButton
                className={this.props.classes.saveButton}
                color="danger"
                size="sm"
                onClick={this.props.closeNewUserModal}
              >
                <SmallUppercase light>Cancel</SmallUppercase>
              </RegularButton>
              <RegularButton
                className={this.props.classes.saveButton}
                color="info"
                size="sm"
                onClick={this.submit}
                disabled={!this.readyToSubmit()}
              >
                <SmallUppercase light>add user</SmallUppercase>
              </RegularButton>
            </GridItem>
          </GridContainer>
        </GridItem>
      </Dialog>
    );
  }
}

export default connect((state) => ({
  stores: state.app.stores,
  user: state.app.user,
}))(withStyles(styles)(NewUserModal));
